import React from 'react';
import './DisplayMessage.css';
export var DisplayMessageTypes;
(function (DisplayMessageTypes) {
    DisplayMessageTypes["Warning"] = "warning";
    DisplayMessageTypes["Error"] = "error";
    DisplayMessageTypes["Success"] = "success";
    DisplayMessageTypes["Info"] = "info";
})(DisplayMessageTypes || (DisplayMessageTypes = {}));
const DisplayMessage = ({ type, message, onClose, style, className }) => {
    const alertTypeMap = {
        warning: 'alert-warning',
        error: 'alert-danger',
        success: 'alert-success',
        info: 'alert-info',
    };
    return (React.createElement("div", { style: { maxWidth: '400px', ...style }, className: `alert ${alertTypeMap[type]} alert-dismissible fade show ${className}`, role: "alert" },
        message,
        onClose && (React.createElement("button", { onClick: onClose, type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close" },
            React.createElement("span", { "aria-hidden": "true" }, "\u00D7")))));
};
export default DisplayMessage;
